// AUTH related types
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';

export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL';

export const DEV_USER_LOGIN_SUCCESS = 'DEV_USER_LOGIN_SUCCESS';
export const DEV_USER_LOGIN_FAIL = 'DEV_USER_LOGIN_FAIL';

export const DEV_USER_DETAILS_SUCCESS = 'DEV_USER_DETAILS_SUCCESS';
export const DEV_USER_DETAILS_FAIL = 'DEV_USER_DETAILS_FAIL';

// USER related types

export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAIL = 'GET_USER_FAIL';

export const SET_LOADING = 'SET_LOADING';
export const CLEAR_ERROR = 'CLEAR_ERROR';

export const SET_USER_LOADING = 'SET_USER_LOADING';
export const CLEAR_USER_ERROR = 'CLEAR_USER_ERROR';

// ACCOUNT TYPES
export const ADD_ACCOUNT_SUCCESS = 'ADD_ACCOUNT_SUCCESS';
export const ADD_ACCOUNT_FAIL = 'ADD_ACCOUNT_FAIL';

export const GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS';
export const GET_ACCOUNT_FAIL = 'GET_ACCOUNT_FAIL';

export const GET_ACCOUNTS_SUCCESS = 'GET_ACCOUNTS_SUCCESS';
export const GET_ACCOUNTS_FAIL = 'GET_ACCOUNTS_FAIL';

export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS';
export const UPDATE_ACCOUNT_FAIL = 'UPDATE_ACCOUNT_FAIL';

export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_FAIL = 'DELETE_ACCOUNT_FAIL';

export const SET_ACCOUNT_LOADING = 'SET_ACCOUNT_LOADING';
export const CLEAR_ACCOUNT_ERROR = 'CLEAR_ACCOUNT_ERROR';

export const GET_VALIDATORS_SUCCESS = 'GET_VALIDATORS_SUCCESS';
export const GET_VALIDATORS_FAIL = 'GET_VALIDATORS_FAIL';

// REPORT TYPES

export const ADD_REPORT_SUCCESS = 'ADD_REPORT_SUCCESS';
export const ADD_REPORT_FAIL = 'ADD_REPORT_FAIL';

export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';
export const GET_REPORT_FAIL = 'GET_REPORT_FAIL';

export const GET_REPORTS_SUCCESS = 'GET_REPORTS_SUCCESS';
export const GET_REPORTS_FAIL = 'GET_REPORTS_FAIL';

export const UPDATE_REPORT_SUCCESS = 'UPDATE_REPORT_SUCCESS';
export const UPDATE_REPORT_FAIL = 'UPDATE_REPORT_FAIL';

export const SET_REPORT_LOADING = 'SET_REPORT_LOADING';
export const CLEAR_REPORT_ERROR = 'CLEAR_REPORT_ERROR';

export const DELETE_REPORT_SUCCESS = 'DELETE_REPORT_SUCCESS';
export const DELETE_REPORT_FAIL = 'DELETE_REPORT_FAIL';

// DATABASE TYPES
export const ADD_DB_SUCCESS = 'ADD_DB_SUCCESS';
export const ADD_DB_FAIL = 'ADD_DB_FAIL';

export const GET_DB_SUCCESS = 'GET_DB_SUCCESS';
export const GET_DB_FAIL = 'GET_DB_FAIL';

export const GET_DBS_SUCCESS = 'GET_DBS_SUCCESS';
export const GET_DBS_FAIL = 'GET_DBS_FAIL';

export const UPDATE_DB_SUCCESS = 'UPDATE_DB_SUCCESS';
export const UPDATE_DB_FAIL = 'UPDATE_DB_FAIL';

export const DELETE_DB_SUCCESS = 'DELETE_DB_SUCCESS';
export const DELETE_DB_FAIL = 'DELETE_DB_FAIL';

export const SET_DB_LOADING = 'SET_DB_LOADING';
export const CLEAR_DB_ERROR = 'CLEAR_DB_ERROR';

// PROJECT TYPES
export const ADD_PROJECT_SUCCESS = 'ADD_PROJECT_SUCCESS';
export const ADD_PROJECT_FAIL = 'ADD_PROJECT_FAIL';

export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export const GET_PROJECT_FAIL = 'GET_PROJECT_FAIL';

export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
export const GET_PROJECTS_FAIL = 'GET_PROJECTS_FAIL';

export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_FAIL = 'UPDATE_PROJECT_FAIL';

export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_FAIL = 'DELETE_PROJECT_FAIL';

export const SET_PROJECT_LOADING = 'SET_PROJECT_LOADING';
export const CLEAR_PROJECT_ERROR = 'CLEAR_PROJECT_ERROR';

// Validation TYPES
export const GET_VALIDATIONS_SUCCESS = 'GET_VALIDATIONS_SUCCESS';
export const GET_VALIDATIONS_FAIL = 'GET_ VALIDATIONS_FAIL';

export const UPDATE_VALIDATION_SUCCESS = 'UPDATE_VALIDATION_SUCCESS';
export const UPDATE_VALIDATION_FAIL = 'UPDATE_VALIDATION_FAIL';

export const SET_VALIDATION_LOADING = 'SET_VALIDATION_LOADING';
export const CLEAR_VALIDATION_ERROR = 'CLEAR_VALIDATION_ERROR';

// D-Rive TYPES
export const ADD_DRIVE_PROJECT_SUCCESS = 'ADD_DRIVE_PROJECT_SUCCESS';
export const ADD_DRIVE_PROJECT_FAIL = 'ADD_DRIVE_PROJECT_FAIL';

export const GET_DRIVE_PROJECT_SUCCESS = 'GET_DRIVE_PROJECT_SUCCESS';
export const GET_DRIVE_PROJECT_FAIL = 'GET_DRIVE_PROJECT_FAIL';

export const GET_DRIVE_PROJECTS_SUCCESS = 'GET_DRIVE_PROJECTS_SUCCESS';
export const GET_DRIVE_PROJECTS_FAIL = 'GET_DRIVE_PROJECTS_FAIL';

export const UPDATE_DRIVE_PROJECT_SUCCESS = 'UPDATE_DRIVE_PROJECT_SUCCESS';
export const UPDATE_DRIVE_PROJECT_FAIL = 'UPDATE_DRIVE_PROJECT_FAIL';

export const DELETE_DRIVE_PROJECT_SUCCESS = 'DELETE_DRIVE_PROJECT_SUCCESS';
export const DELETE_DRIVE_PROJECT_FAIL = 'DELETE_DRIVE_PROJECT_FAIL';

export const SET_DRIVE_PROJECT_LOADING = 'SET_DRIVE_PROJECT_LOADING';
export const CLEAR_DRIVE_PROJECT_ERROR = 'CLEAR_DRIVE_PROJECT_ERROR';
